import React from 'react'

import { Box, CircularProgress, Dialog, Table, TableBody, TableContainer } from '@material-ui/core'

import { CommissionsRow } from '../CommissionRow'
import { CommissionsTableHead } from '../CommissionTableHead'

import { OrderCommissionModel } from '../../server/mpsklad_core/Models/OrderCommissionModel'

export type CommissionsDialogProps = {
  isLoading: boolean

  commissions: OrderCommissionModel[] | null

  reset: VoidFunction
};

export const CommissionsDialog =
  ({isLoading, commissions, reset}: CommissionsDialogProps) => {
    if (!isLoading && !commissions) {
      return null
    }

    return (
      <Dialog open onClose={reset} maxWidth={false}>
        {
          isLoading
          ?
          <Box padding={3} display="flex" justifyContent="center">
            <CircularProgress size={32}/>
          </Box>
          : commissions?.length
            ?
            <TableContainer>
              <Table>
                <CommissionsTableHead/>

                <TableBody>
                  {
                    commissions.map(commission =>
                      <CommissionsRow key={commission.name} commission={commission}/>)
                  }
                </TableBody>
              </Table>
            </TableContainer>
            :
            <Box padding={3} textAlign="center">
              Нет данных о комиссиях.
            </Box>
        }
      </Dialog>
    )
  }